// auto-generated by Typewriter template _enums.tst from PortCall.EndPoints\Api\PortCallChange\ApiPortCallChange.cs
export enum PortCallChangeType { 
    Berth = 1,
    LineTime = 2,
    Vessel = 3,
    LineTimeActual = 4,
    AttendingAgent = 5,
    Footmark = 6,
    InvitedEditor = 7,
    ShiftAdded = 8,
    ReservationStatus = 9,
    Watcher = 10,
    Creation = 11,
    SideTo = 12,
    Barge = 13,
    Berth_DEPRECATED_20170306 = 14,
    LineTime_DEPRECATED_20170308 = 15,
    Footmark_DEPRECATED_20170306 = 16,
    Creation_DEPRECATED_20170302 = 17,
    ApprovalCard_DEPRECATED_20161125 = 18,
    ShiftAdded_DEPRECATED_20161117 = 19,
    ReservationStatus_DEPRECATED_20161117 = 20,
    SideTo_DEPRECATED_20170306 = 21,
    Schedule = 22
}

export const PortCallChangeTypeDisplayName : { [val : number] : string } = { 
    1: 'Berth',
    2: 'LineTime',
    3: 'Vessel',
    4: 'LineTimeActual',
    5: 'AttendingAgent',
    6: 'Footmark',
    7: 'InvitedEditor',
    8: 'ShiftAdded',
    9: 'ReservationStatus',
    10: 'Watcher',
    11: 'Creation',
    12: 'SideTo',
    13: 'Barge',
    14: 'Berth_DEPRECATED_20170306',
    15: 'LineTime_DEPRECATED_20170308',
    16: 'Footmark_DEPRECATED_20170306',
    17: 'Creation_DEPRECATED_20170302',
    18: 'ApprovalCard_DEPRECATED_20161125',
    19: 'ShiftAdded_DEPRECATED_20161117',
    20: 'ReservationStatus_DEPRECATED_20161117',
    21: 'SideTo_DEPRECATED_20170306',
    22: 'Schedule'
}

export const PortCallChangeTypes : { Id : PortCallChangeType, Name : string }[] = [ 
    { Id: PortCallChangeType.Berth, Name: 'Berth' },
    { Id: PortCallChangeType.LineTime, Name: 'LineTime' },
    { Id: PortCallChangeType.Vessel, Name: 'Vessel' },
    { Id: PortCallChangeType.LineTimeActual, Name: 'LineTimeActual' },
    { Id: PortCallChangeType.AttendingAgent, Name: 'AttendingAgent' },
    { Id: PortCallChangeType.Footmark, Name: 'Footmark' },
    { Id: PortCallChangeType.InvitedEditor, Name: 'InvitedEditor' },
    { Id: PortCallChangeType.ShiftAdded, Name: 'ShiftAdded' },
    { Id: PortCallChangeType.ReservationStatus, Name: 'ReservationStatus' },
    { Id: PortCallChangeType.Watcher, Name: 'Watcher' },
    { Id: PortCallChangeType.Creation, Name: 'Creation' },
    { Id: PortCallChangeType.SideTo, Name: 'SideTo' },
    { Id: PortCallChangeType.Barge, Name: 'Barge' },
    { Id: PortCallChangeType.Berth_DEPRECATED_20170306, Name: 'Berth_DEPRECATED_20170306' },
    { Id: PortCallChangeType.LineTime_DEPRECATED_20170308, Name: 'LineTime_DEPRECATED_20170308' },
    { Id: PortCallChangeType.Footmark_DEPRECATED_20170306, Name: 'Footmark_DEPRECATED_20170306' },
    { Id: PortCallChangeType.Creation_DEPRECATED_20170302, Name: 'Creation_DEPRECATED_20170302' },
    { Id: PortCallChangeType.ApprovalCard_DEPRECATED_20161125, Name: 'ApprovalCard_DEPRECATED_20161125' },
    { Id: PortCallChangeType.ShiftAdded_DEPRECATED_20161117, Name: 'ShiftAdded_DEPRECATED_20161117' },
    { Id: PortCallChangeType.ReservationStatus_DEPRECATED_20161117, Name: 'ReservationStatus_DEPRECATED_20161117' },
    { Id: PortCallChangeType.SideTo_DEPRECATED_20170306, Name: 'SideTo_DEPRECATED_20170306' },
    { Id: PortCallChangeType.Schedule, Name: 'Schedule' }
]



// WEBPACK FOOTER //
// ./server/enums/PortCallChangeType.ts